import store from 'src/redux/store';
import { getRoute, PATH } from './routes';
import router from 'next/router';
import { setPaymentModalVisiblity } from 'src/redux/actions';

export function redirectToFailedPaymentPage(hash, storeDomain, isPostPaidOrder) {
  store.dispatch(setPaymentModalVisiblity(false));
  router.push(
    getRoute(
      PATH.paymentFailed(hash) + (isPostPaidOrder ? '?postpaid=true' : ''),
      storeDomain
    )
  );
}
